import React from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'

import Layout from 'layouts/Layout'
import Topbar from 'layouts/Topbar'
import Tabs from 'components/Tabs'

const Home = () => {
  const { t } = useTranslation('global')

  return (
    <Layout>
      <Topbar
        // cta={t('save_search')}
        icon={<FontAwesomeIcon icon={faBuilding} />}
        title={t('home')}
        number={''}
      />
      <Tabs
        activeTab={{name: t('my_companies'), id: '45434'}}
        tabs={[{name: t('my_companies'), id: '45434'}]}
      />
      <div className='home'>
        
      </div>
    </Layout>
  )
}

export default Home
